"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateExperimentStatusRequestToJSON = exports.UpdateExperimentStatusRequestFromJSONTyped = exports.UpdateExperimentStatusRequestFromJSON = exports.instanceOfUpdateExperimentStatusRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateExperimentStatusRequest interface.
 */
function instanceOfUpdateExperimentStatusRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateExperimentStatusRequest = instanceOfUpdateExperimentStatusRequest;
function UpdateExperimentStatusRequestFromJSON(json) {
    return UpdateExperimentStatusRequestFromJSONTyped(json, false);
}
exports.UpdateExperimentStatusRequestFromJSON = UpdateExperimentStatusRequestFromJSON;
function UpdateExperimentStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
    };
}
exports.UpdateExperimentStatusRequestFromJSONTyped = UpdateExperimentStatusRequestFromJSONTyped;
function UpdateExperimentStatusRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
    };
}
exports.UpdateExperimentStatusRequestToJSON = UpdateExperimentStatusRequestToJSON;
